import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import "./WhiteLoginButton.css";

export default class WhiteLoginButton extends React.Component {
  render() {
    return (
      <Link to={this.props.to} style={this.props.linkStyle}>
        <button className="whiteLoginButton" style={this.props.buttonStyle}>
          {this.props.title}
        </button>
      </Link>
    );
  }
}

WhiteLoginButton.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  linkStyle: PropTypes.object,
  buttonStyle: PropTypes.object
};
